import PropTypes from 'prop-types'
import * as Sentry from '@sentry/react'
import { EMPTY_MESSAGE_LABELS, TABLAS_LABELS, ALERT_MESSAGES } from '../../../common/constants/labels'
import { FeedBackMessage, PrimaryButton, Text } from '@artprov/design-system'
import { generateReporteInsiSinDatos } from '../api/informesApi'

const EmptyMessage = ({ periodoData, contrato, onError, onSuccess }) => {
  const formatearFecha = (fecha) => {
    if (fecha?.length !== 6) return fecha
    const year = fecha.substring(0, 4)
    const month = fecha.substring(4, 6)
    return `${month}/${year}`
  }

  const handleDownloadSinDatos = async () => {
    if (!contrato) {
      onError?.('No se encontró el número de contrato')
      return
    }

    if (!periodoData) {
      onError?.('No se encontraron las fechas del periodo')
      return
    }

    try {
      const response = await generateReporteInsiSinDatos({
        contrato,
        periodoDesde: formatearFecha(periodoData.fechaDesde),
        periodoHasta: formatearFecha(periodoData.fechaHasta),
      })

      const reportUrl = response.data?.url
      if (reportUrl) {
        window.open(reportUrl, '_blank', 'noopener,noreferrer')
      }

      onSuccess?.(ALERT_MESSAGES.successMsj)
    } catch (error) {
      Sentry.captureException(error, {
        tags: { feature: 'reporting', action: 'download-sin-datos' },
      })
      onError?.(ALERT_MESSAGES.errorMsj)
    }
  }

  return (
    <div className="w-full flex items-center justify-center flex-col mt-8 sm:mt-16 px-4">
      <div className="flex w-80 items-center">
        <FeedBackMessage
          icon="error"
          iconStyles="text-warning-10"
          title={EMPTY_MESSAGE_LABELS.TITLE}
          titleStyles="text-primary-10 font-bold"
          description={EMPTY_MESSAGE_LABELS.DESCRIPTION}
        />
      </div>
      <div className="mt-4">
        <PrimaryButton
          size="small"
          IconLeft="DOWNLOAD"
          variant="default"
          className="h-[36px] flex items-center justify-center"
          onClick={handleDownloadSinDatos}
        >
          Descargar
        </PrimaryButton>
      </div>
    </div>
  )
}

export const JudicialesEmptyMessage = () => {
  return (
    <>
      <Text variant="h7" className="mt-6 mb-6 text-primary-10">
        {TABLAS_LABELS.TOP_JUDICIALES}
      </Text>
      <div className="w-full mb-6 rounded border border-tertiary-80 bg-tertiary-95 px-4 py-3 h-16 flex items-center">
        <Text variant="body2" className="text-tertiary-40 font-semibold">
          {TABLAS_LABELS.NO_JUICIOS_MESSAGE}
        </Text>
      </div>
    </>
  )
}

EmptyMessage.propTypes = {
  periodoData: PropTypes.shape({
    fechaDesde: PropTypes.string,
    fechaHasta: PropTypes.string,
  }),
  contrato: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
}

export default EmptyMessage
